import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Query from '../../../../GraphQL/util/QueryComponent';
import { getExamAssets } from '../../../../GraphQL/query/MockExam.query';

import ExamInfo from './ExamInfo';

const getExamAsset = mockExamAsset => {
  if (!mockExamAsset) return {};

  const { questionPapers, solutionPapers } = mockExamAsset || {};
  const examPapers = questionPapers || [];
  const examKeys = solutionPapers || [];
  const disableExamPaper = examPapers.length === 0;
  const disableExamKey = examKeys.length === 0;
  const downloadExamPaperUrl = !disableExamPaper ? examPapers[0].url : undefined;
  const downloadExamKeyUrl = !disableExamKey ? examKeys[0].url : undefined;
  return { disableExamPaper, disableExamKey, downloadExamPaperUrl, downloadExamKeyUrl };
};

class ExamInfoQuery extends Component {
  static propTypes = {
    examId: PropTypes.string,
  };

  render() {
    const { examId } = this.props;

    return (
      <Query
        query={getExamAssets}
        variables={{ mockExamId: examId }}
        renderLoading={() => <ExamInfo {...this.props} />}
        renderError={() => <ExamInfo {...this.props} />}
      >
        {({ mockExamAsset }) => <ExamInfo {...this.props} {...getExamAsset(mockExamAsset)} />}
      </Query>
    );
  }
}

export default ExamInfoQuery;
